import { getMessageFactory } from "../getCaxaWebSocket.js";
const getChangedInfo = getMessageFactory({
  code: "GET_CHANGED_INFO"
});
export { getChangedInfo };



// WEBPACK FOOTER //
// ./~/@oppein/op-utils/dist/es/external/caxa/directive/getChangedInfo.js